export default Object.freeze({
    // REJECTED: 0, // Blacklist - No aprobada 00 Cuando se rechaza
    // REJECTED_FOR_SHELL_COMPANY: 1, // Blacklist - Empresa Fantasma 01 Cuando se rechaza
    // REJECTED_FOR_PLD: 2, // Blacklist - Empresa PLD 02 Cuando se rechaza
    // PENDING: 10, // 10 Cuando falta aprobación
    // APPROVED: 20, // 20 Cuando esta aprobada
    // DISABLED: 30, // Una vez aprobada se desactiva para detener subida de facturas,
    REJECTED: 0,
    PENDING: 10,
    APPROVED: 20,
    RESTRICTED: 30
})
